import { BATTLE_EFFECT_PREVIEW_LINES, BATTLE_SHOW_STATS_AT_REST } from 'features/catalog/rarity-config';

/** Battle badges always show the effect preview. */
export const applyBattleDetail = () => {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.bbDetail = 'effect';
  document.documentElement.dataset.bbEffectLines = String(BATTLE_EFFECT_PREVIEW_LINES);
  document.documentElement.dataset.bbStatsRest = BATTLE_SHOW_STATS_AT_REST ? '1' : '0';
  document.documentElement.style.setProperty('--bb-effect-lines', String(BATTLE_EFFECT_PREVIEW_LINES));
};

applyBattleDetail();
